import { helpingMethod } from '../../../utils/HelpingMethod';
import { logger } from '../../../services/logger/logger';

const priceListApiParsers: any = {};

priceListApiParsers.getPriceList = (data: any) => {
  // Handle different response structures from backend
  let priceListArray: any[] = [];

  if (Array.isArray(data)) {
    // Direct array response
    priceListArray = data;
  } else if (data && typeof data === 'object') {
    // Response wrapped in object - try common property names
    priceListArray = data.data || data.priceLists || data.pricelists || data.items || [];
  }

  if (!Array.isArray(priceListArray)) {
    return [];
  }

  return priceListArray.map((item: any) => {
    const dateFrom = helpingMethod.formatDate(item?.dateFrom);
    const dateTo = helpingMethod.formatDate(item?.dateTo);
    // Always show dash after start date, with or without end date
    const validityDateRange = dateFrom ? `${dateFrom} - ${dateTo || ''}` : '';

    // Retrieve document ID from localStorage
    // Use the same key format as when saving: priceList_doc_{customerId}_{supplierId}_{dateFrom}_{dateTo}
    let documentNb = '';
    try {
      const customerId = item?.customerId;
      const supplierId = item?.supplierId;
      const dateFromOriginal = item?.dateFrom; // Use original format (YYYY-MM-DD)
      const dateToOriginal = item?.dateTo;

      if (customerId && supplierId && dateFromOriginal && dateToOriginal) {
        const storageKey = `priceList_doc_${customerId}_${supplierId}_${dateFromOriginal}_${dateToOriginal}`;
        documentNb = localStorage.getItem(storageKey) || '';
      }
    } catch (storageError) {
      logger.error('Failed to retrieve document ID from localStorage', storageError as Error);
    }

    return {
      srno: item?.id ?? '',
      customer: item?.customerName ?? '',
      supplier: item?.supplierName ?? '',
      currency: item?.currencyCode ?? '',
      validityDateRange,
      documentNb, // Add document ID from localStorage
      // keep originals in case details page or future use needs them
      id: item?.id,
      customerId: item?.customerId,
      supplierId: item?.supplierId,
      currencyId: item?.currencyId,
      totalProducts: item?.totalProducts,
      dateFrom: item?.dateFrom,
      dateTo: item?.dateTo,
    };
  });
};

priceListApiParsers.getPriceListProducts = (data: any) => {
  // Handle different response structures from backend
  let productsArray: any[] = [];

  if (Array.isArray(data)) {
    // Direct array response
    productsArray = data;
  } else if (data && typeof data === 'object') {
    // Response wrapped in object - try common property names
    productsArray = data.data || data.products || data.items || [];
  }

  if (!Array.isArray(productsArray)) {
    return [];
  }

  return productsArray.map((item: any) => ({
    // grid fields
    productName: item?.productName ?? '',
    port: item?.portName ?? '',
    price: typeof item?.price === 'number' ? item.price : Number(item?.price ?? 0),

    // keep originals for future usage/editing
    productId: item?.productId,
    categoryId: item?.categoryId,
    categoryName: item?.categoryName,
    categoryShowOrder: item?.categoryShowOrder,
    makerId: item?.makerId,
    makerName: item?.makerName,
    portId: item?.portId,
    portName: item?.portName,
  }));
};

export default priceListApiParsers;
